import { css } from 'lit';
export const styles = css `
:host(:focus){outline:0}:host ::slotted([id^=hds-list-item-]){margin-bottom:var(--hds-spacing-2)}:host ::slotted([id^=hds-list-item-]:last-of-type){margin-bottom:var(--hds-spacing-0)}
`;
//# sourceMappingURL=hds-rich-list.css.js.map